export const FLOW_STATUS = {
  LIVE: "Live",
  DRAFT: "Draft",
  PENDING: "Pending",
  ARCHIVED: "Archived",
  DELETED: "Deleted"
};

export const SUB_FLOW_TYPES = {
  FORMVIEW: "FormView",
  REPORT: "Report",
  CASEVIEW: "CaseView",
  ANALYTICS_REPORT: "AnalyticsReport"
};
